export enum ProfileQueryKey {
	GetTOTPGenerate = 'profile.getTOTPGenerate',
}

export enum ProfileMutationKey {
	Enable2FA = 'profile.enable2FA',
	Disable2FA = 'profile.disable2FA',
	ResetTOTP = 'profile.resetTOTP',
	ResetPassword = 'profile.resetPassword',
}
